var map = {
	"./ansible.png": 5769,
	"./ansible_bw.png": 5799,
	"./awk.png": 8410,
	"./cloudscaling.png": 3899,
	"./cloudscaling_bw.png": 5561,
	"./cplusplus.png": 6938,
	"./cplusplus_bw.png": 8686,
	"./csharp.png": 2336,
	"./csharp_bw.png": 3236,
	"./dellemc.png": 503,
	"./dellemc_bw.png": 3213,
	"./devops.png": 3750,
	"./devops_bw.png": 5666,
	"./docker.png": 7289,
	"./docker_bw.png": 7751,
	"./go.png": 7939,
	"./go_bw.png": 7889,
	"./helm.jpg": 4361,
	"./helm.png": 5745,
	"./helm_bw.png": 6175,
	"./java.png": 9301,
	"./java_bw.png": 6411,
	"./juju.png": 5265,
	"./juju_bw.png": 8671,
	"./juniper.png": 4820,
	"./juniper_bw.png": 4000,
	"./kubernetes.png": 1581,
	"./kubernetes_bw.png": 2707,
	"./linux.png": 571,
	"./linux_bw.png": 3817,
	"./linux_foundation.png": 3479,
	"./linux_foundation_bw.png": 7805,
	"./logo.jpg": 7664,
	"./mailru.png": 1967,
	"./mailru_bw.png": 4645,
	"./okb.png": 5293,
	"./openstack.png": 2157,
	"./openstack_bw.png": 3107,
	"./opnfv.png": 7328,
	"./opnfv_bw.png": 3876,
	"./puppet.png": 259,
	"./puppet_bw.png": 8705,
	"./python.png": 5071,
	"./python_bw.png": 5125,
	"./redhat.png": 8737,
	"./redhat_bw.png": 9103,
	"./scaleio.png": 6295,
	"./scaleio_bw.png": 4717,
	"./tf.png": 8127,
	"./tf_bw.png": 2021,
	"./tinkoff.png": 6342,
	"./ubuntu.png": 6836,
	"./ubuntu_bw.png": 8944,
	"./vk.png": 9948,
	"./windows.png": 1214,
	"./windows_bw.png": 5450,
	"./witology.png": 2597,
	"./witology_bw.png": 6267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3865;